import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

export type JoinWaitlistParams = {
  profile_id: string;
  variant_id: string;
  country: string;
  metadata: {
    waitlist_reason: string;
  };
};

export type JoinWaitlistResponse = {
  status: string;
  info: string;
  message: string;
};

export const joinWaitlist = (
  params: JoinWaitlistParams
): Promise<JoinWaitlistResponse> => {
  return axios.post('/user/v1/waitlist/join', params);
};

export const joinWaitlistMockHandler = http.post(
  `${env.API_URL}/user/v1/waitlist/join`,
  async (): Promise<HttpResponse<JoinWaitlistResponse>> => {
    await networkDelay();

    const mockResponse: JoinWaitlistResponse = {
      status: 'success',
      info: 'operation successful',
      message: 'Successfully joined waitlist',
    };

    return HttpResponse.json(mockResponse);
  }
);
